<script lang="ts">
    export let borderColor = "blue"
    export function shine() {
        startShining = true;
        shineFirst = !shineFirst;
    }

    let startShining = false;
    let shineFirst = true;
</script>

<div
    class="result-box full-w full-h border-radius-pico-border-radius border-solid-2px border-{borderColor} center-contents-vh background-color-pico-background"
>
    <slot />
    <div
        class:shiner={startShining}
        class:shine_first={shineFirst}
        class:shine_second={!shineFirst}
        class="background-color-{borderColor}"
    ></div>
</div>
